// extracted by mini-css-extract-plugin
export var logo = "_iv-2";
export var logoWrapper = "_iv-1";
export var strip = "_iv-0";